import { render, staticRenderFns } from "./UserSettingsView.vue?vue&type=template&id=15036d64&scoped=true&"
import script from "./UserSettingsView.vue?vue&type=script&lang=js&"
export * from "./UserSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsView.vue?vue&type=style&index=0&id=15036d64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15036d64",
  null
  
)

export default component.exports
import {QTabs,QRouteTab,QSeparator} from 'quasar'
component.options.components = Object.assign({QTabs,QRouteTab,QSeparator}, component.options.components || {})
